<template>
  <div class="col-sm-12 col-lg-5 detail d-none d-lg-block">
  <!-- <div class="col-sm-12 col-lg-5 mx-0 px-0 mobile-100 detail"> -->
    <img
      src="@/assets/images/logomenu.png"
      class="rounded mx-auto d-block mt-5 mb-1 logooliver"
      />
      <div>
        <img
        src="@/assets/images/calendar_next_meeting.png"
        class="rounded mx-auto d-block mt-5 mb-2 calendar"
        />
      </div>
      <div class="row d-flex justify-content-center mt-4 text-center text-white">
        <div class="col-12">
          <h4>{{$t('lang.label.login-get-meeting')}}</h4>
          <h6 class="mt-5">{{$t('lang.label.login-pay')}}</h6>
        </div>
        <div class="col-12 d-flex justify-content-center mb-3">
          <ul>
            <li class="my-2 d-flex justify-content-start">
              <div>
                <img
                  src="@/assets/images/icons_login/calendar.png"
                  class="icon-feature"
                />
                <span class="mx-2"><h6>{{$t('lang.label.login-agenda')}}</h6></span>
              </div>
            </li>

            <li class="my-2 d-flex justify-content-start">
              <div>
                <img
                  src="@/assets/images/icons_login/target.png"
                  class="icon-feature"
                />
                <span class="mx-2" ><h6>{{$t('lang.label.login-target')}}</h6></span>
              </div>
            </li>
            <li class="my-2 d-flex justify-content-start">
              <div>
                <img
                  src="@/assets/images/icons_login/user.png"
                  class="icon-feature"
                />
                <span class="mx-2"><h6>{{$t('lang.label.login-prospects')}}</h6></span>
              </div>
            </li>
            <li class="my-2 d-flex justify-content-start">
              <div>
                <img
                  src="@/assets/images/icons_login/dollar.png"
                  class="icon-feature"
                />
                <span class="mx-2"><h6>{{$t('lang.label.login-fixed-meeting')}}</h6></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style scoped>
.detail {
  background-color: #1f2041;
}
h4 {
  font-weight: 300
}
h6 {
  font-weight: 300;
}
.logooliver {
  width: 120px;
}
.calendar {
  width: 240px;
}
.border border-dark {
  border:2px solid red
}

.icon-feature {
  width: 28px;
}
</style>
